import { render, staticRenderFns } from "./commissionSettings.vue?vue&type=template&id=80df13a2&scoped=true&"
import script from "./commissionSettings.vue?vue&type=script&lang=js&"
export * from "./commissionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80df13a2",
  null
  
)

export default component.exports